<template>
    <UserStatusChanged v-if="activity.type === ActivityTypes.USER_STATUS_CHANGED.id" :activity="activity" />
    <VisitorBlocked v-else-if="activity.type === ActivityTypes.BLOCK_VISITOR.id" :activity="activity" />
    <VisitorUnBlocked v-else-if="activity.type === ActivityTypes.UNBLOCK_VISITOR.id" :activity="activity" />
    <VisitorTagAdded v-else-if="activity.type === ActivityTypes.VISITOR_TAG_ADDED.id" :activity="activity" />
    <VisitorTagRemoved v-else-if="activity.type === ActivityTypes.VISITOR_TAG_REMOVED.id" :activity="activity" />
    <UserAdded v-else-if="activity.type === ActivityTypes.USER_ADDED.id" :activity="activity" />
    <ChannelCreated v-else-if="activity.type === ActivityTypes.CHANNEL_CREATED.id" :activity="activity" />
    <ChannelRemoved v-else-if="activity.type === ActivityTypes.CHANNEL_REMOVED.id" :activity="activity" />
    <ChatOpened v-else-if="activity.type === ActivityTypes.CHAT_OPENED.id" :activity="activity" />
    <ChatClosed v-else-if="activity.type === ActivityTypes.CHAT_CLOSED.id" :activity="activity" />
    <WebhookAdded v-else-if="activity.type === ActivityTypes.WEBHOOK_ADDED.id" :activity="activity" />
    <WebhookRemoved v-else-if="activity.type === ActivityTypes.WEBHOOK_REMOVED.id" :activity="activity" />
    <WebhookUpdated v-else-if="activity.type === ActivityTypes.WEBHOOK_UPDATED.id" :activity="activity" />
    <TriggerAdded v-else-if="activity.type === ActivityTypes.TRIGGER_ADDED.id" :activity="activity" />
    <TriggerRemoved v-else-if="activity.type === ActivityTypes.TRIGGER_REMOVED.id" :activity="activity" />
    <TriggerUpdated v-else-if="activity.type === ActivityTypes.TRIGGER_UPDATED.id" :activity="activity" />
    <DepartmentAdded v-else-if="activity.type === ActivityTypes.DEPARTMENT_ADDED.id" :activity="activity" />
    <DepartmentRemoved v-else-if="activity.type === ActivityTypes.DEPARTMENT_REMOVED.id" :activity="activity" />
    <RoleAdded v-else-if="activity.type === ActivityTypes.ROLE_ADDED.id" :activity="activity" />
    <RoleRemoved v-else-if="activity.type === ActivityTypes.ROLE_REMOVED.id" :activity="activity" />
    <TagsAdded v-else-if="activity.type === ActivityTypes.TAGS_ADDED.id" :activity="activity" />
    <TagsRemoved v-else-if="activity.type === ActivityTypes.TAGS_REMOVED.id" :activity="activity" />
    <WelcomeMessageAdded v-else-if="activity.type === ActivityTypes.WELCOME_MESSAGE_ADDED.id" :activity="activity" />

    <WelcomeMessageRemoved
        v-else-if="activity.type === ActivityTypes.WELCOME_MESSAGE_REMOVED.id"
        :activity="activity"
    />
    <BannedWordCreated v-else-if="activity.type === ActivityTypes.BANNED_WORD_ADDED.id" :activity="activity" />
    <BannedWordRemoved v-else-if="activity.type === ActivityTypes.BANNED_WORD_REMOVED.id" :activity="activity" />
    <TaskWorkflwCreated v-else-if="activity.type === ActivityTypes.TASK_WORKFLOW_CREATED.id" :activity="activity" />
    <SettingsUpdated v-else-if="activity.type === ActivityTypes.SETTINGS_UPDATED.id" :activity="activity" />
    <MailAddressAdded v-else-if="activity.type === ActivityTypes.MAIL_ADDRESS_ADDED.id" :activity="activity" />
    <UserAddedToDepartment
        v-else-if="activity.type === ActivityTypes.USER_ADDED_TO_DEPARTMENT.id"
        :activity="activity"
    />
    <UserRemovedFromDepartment
        v-else-if="activity.type === ActivityTypes.USER_REMOVED_FROM_DEPARTMENT.id"
        :activity="activity"
    />
    <TaskDeleted v-else-if="activity.type === ActivityTypes.TASK_DELETED.id" :activity="activity" />
    <ChannelVisibilityChanged
        v-else-if="activity.type === ActivityTypes.CHANNEL_VISIBILITY_CHANGED.id"
        :activity="activity"
    />
    <ChannelForwardConfigUpdated
        v-else-if="activity.type === ActivityTypes.CHANNEL_FORWARD_CONFIG_UPDATED.id"
        :activity="activity"
    />
    <ChannelZohoConfigUpdated
        v-else-if="activity.type === ActivityTypes.CHANNEL_ZOHO_CONFIG_UPDATED.id"
        :activity="activity"
    />
    <ContentAdded v-else-if="activity.type === ActivityTypes.CONTENT_ADDED.id" :activity="activity" />
    <ContentRemoved v-else-if="activity.type === ActivityTypes.CONTENT_REMOVED.id" :activity="activity" />
    <CustomerGroupAdded v-else-if="activity.type === ActivityTypes.CUSTOMER_GROUP_ADDED.id" :activity="activity" />
    <CustomerGroupRemoved v-else-if="activity.type === ActivityTypes.CUSTOMER_GROUP_REMOVED.id" :activity="activity" />
    <CustomerGroupUpdated v-else-if="activity.type === ActivityTypes.CUSTOMER_GROUP_UPDATED.id" :activity="activity" />
    <ChatAssigned v-else-if="activity.type === ActivityTypes.CHAT_ASSIGNED_TO_USER.id" :activity="activity" />
    <ChatForwarded v-else-if="activity.type === ActivityTypes.CHAT_FORWARDED_TO_USER.id" :activity="activity" />
    <ChatJoined v-else-if="activity.type === ActivityTypes.USER_JOINED_TO_CHAT.id" :activity="activity" />
    <UserLoggedIn v-else-if="activity.type === ActivityTypes.USER_LOGGED_IN.id" :activity="activity" />
    <TicketAssigned v-else-if="activity.type === ActivityTypes.TICKET_ASSIGNED_TO_USER.id" :activity="activity" />
    <WhatsappBroadcastCreated
        v-else-if="activity.type === ActivityTypes.WHATSAPP_BROADCAST_CREATED.id"
        :activity="activity"
    />
    <WhatsappBroadcastCompleted
        v-else-if="activity.type === ActivityTypes.WHATSAPP_BROADCAST_COMPLETED.id"
        :activity="activity"
    />
    <WhatsappBroadcastCancelled
        v-else-if="activity.type === ActivityTypes.WHATSAPP_BROADCAST_CANCELED.id"
        :activity="activity"
    />
    <WhatsappBroadcastFailed
        v-else-if="activity.type === ActivityTypes.WHATSAPP_BROADCAST_FAILED.id"
        :activity="activity"
    />
    <TaskWorkflowDeleted v-else-if="activity.type === ActivityTypes.TASK_WORKFLOW_DELETED.id" :activity="activity" />
    <TaskWorkflowRestored v-else-if="activity.type === ActivityTypes.TASK_WORKFLOW_RESTORED.id" :activity="activity" />
    <TaskWorkflowPermanentlyDeleted v-else-if="activity.type === ActivityTypes.TASK_WORKFLOW_PERMANENTLY_DELETED.id" :activity="activity" />
    <BillingAddressUpdated
        v-else-if="activity.type === ActivityTypes.BILLING_ADDRESS_UPDATED.id"
        :activity="activity"
    />
    <InvoiceCreated v-else-if="activity.type === ActivityTypes.INVOICE_CREATED.id" :activity="activity" />
    <InvoicePaymentReceived
        v-else-if="activity.type === ActivityTypes.INVOICE_PAYMENT_RECEIVED.id"
        :activity="activity"
    />
    <InvoicePaymentFailed v-else-if="activity.type === ActivityTypes.INVOICE_PAYMENT_FAILED.id" :activity="activity" />
    <PaymentMethodAdded v-else-if="activity.type === ActivityTypes.PAYMENT_METHOD_ADDED.id" :activity="activity" />
    <InvoiceRefunded v-else-if="activity.type === ActivityTypes.INVOICE_REFUNDED.id" :activity="activity" />
    <LoginFormActivated v-else-if="activity.type === ActivityTypes.LOGIN_FORM_ACTIVATED.id" :activity="activity" />
    <LoginFormDeactivated v-else-if="activity.type === ActivityTypes.LOGIN_FORM_DEACTIVATED.id" :activity="activity" />
    <LoginFormUpdated v-else-if="activity.type === ActivityTypes.LOGIN_FORM_UPDATED.id" :activity="activity" />
    <UserRemoved v-else-if="activity.type === ActivityTypes.USER_REMOVED.id" :activity="activity" />
    <ContactPropAdded v-else-if="activity.type === ActivityTypes.CONTACT_PROP_ADDED.id" :activity="activity" />
    <ContactPropRemoved v-else-if="activity.type === ActivityTypes.CONTACT_PROP_REMOVED.id" :activity="activity" />
    <TaskCreated v-else-if="activity.type === ActivityTypes.TASK_CREATED.id" :activity="activity" />
    <TaskStageChanged v-else-if="activity.type === ActivityTypes.TASK_STAGE_CHANGED.id" :activity="activity" />
    <TaskAssignedToUser v-else-if="activity.type === ActivityTypes.TASK_ASSIGNED_TO_USER.id" :activity="activity" />
    <TaskUpdatedPriority v-else-if="activity.type === ActivityTypes.TASK_UPDATE_PRIORITY.id" :activity="activity" />
    <TaskAddedTags v-else-if="activity.type === ActivityTypes.TASK_ADDED_TAGS.id" :activity="activity" />
    <TaskRemovedTags v-else-if="activity.type === ActivityTypes.TASK_REMOVED_TAGS.id" :activity="activity" />
    <TaskUpdateTitle v-else-if="activity.type === ActivityTypes.TASK_UPDATE_TITLE.id" :activity="activity" />
    <TaskUpdateDescription v-else-if="activity.type === ActivityTypes.TASK_UPDATE_DESCRIPTION.id" :activity="activity" />
    <TaskUpdateStartDate v-else-if="activity.type === ActivityTypes.TASK_UPDATE_START_DATE.id" :activity="activity" />
    <TaskUpdateEndDate v-else-if="activity.type === ActivityTypes.TASK_UPDATE_END_DATE.id" :activity="activity" />
    <TaskUpdateOwner v-else-if="activity.type === ActivityTypes.TASK_UPDATE_OWNER.id" :activity="activity" />
    <TaskAddedFollowers v-else-if="activity.type === ActivityTypes.TASK_ADDED_FOLLOWERS.id" :activity="activity" />
    <TaskRemovedFollowers v-else-if="activity.type === ActivityTypes.TASK_REMOVED_FOLLOWERS.id" :activity="activity" />
    <TaskAddedCollaborators v-else-if="activity.type === ActivityTypes.TASK_ADDED_COLLABORATORS.id" :activity="activity" />
    <TaskUpdateChecklist v-else-if="activity.type === ActivityTypes.TASK_UPDATE_CHECKLIST.id" :activity="activity" />
    <TaskAddedSubtask v-else-if="activity.type === ActivityTypes.TASK_ADDED_SUBTASK.id" :activity="activity" />
    <TaskRemovedSubtask v-else-if="activity.type === ActivityTypes.TASK_REMOVED_SUBTASK.id" :activity="activity" />
    <TaskAddedAttachment v-else-if="activity.type === ActivityTypes.TASK_ADDED_ATTACHMENT.id" :activity="activity" />
    <TaskComplet v-else-if="activity.type === ActivityTypes.TASK_COMPLETED.id" :activity="activity" />
    <TaskArchived v-else-if="activity.type === ActivityTypes.TASK_ARCHIVED.id" :activity="activity" />
    <TaskRestored v-else-if="activity.type === ActivityTypes.TASK_RESTORED.id" :activity="activity" />
    <TaskUnarchived v-else-if="activity.type === ActivityTypes.TASK_UNARCHIVED.id" :activity="activity" />
    <WhatsappCreditLow v-else-if="activity.type === ActivityTypes.WHATSAPP_CREDIT_LOW.id" :activity="activity" />
    <ChatbotCreated v-else-if="activity.type === ActivityTypes.CHATBOT_CREATED.id" :activity="activity" />
    <ChatBotCreditLow v-else-if="activity.type === ActivityTypes.CHATBOT_CREDIT_LOW.id" :activity="activity" />
    <ChatBotCreditDone v-else-if="activity.type === ActivityTypes.CHATBOT_CREDIT_DONE.id" :activity="activity" />
    <SystemStatusChanged v-else-if="activity.type === ActivityTypes.SYSTEM_STATUS.id" :activity="activity" />
    <ChatbotDeleted v-else-if="activity.type === ActivityTypes.CHATBOT_DELETED.id" :activity="activity" />
    <ChatbotRestored v-else-if="activity.type === ActivityTypes.CHATBOT_RESTORED.id" :activity="activity" />
    <ChatbotPublished v-else-if="activity.type === ActivityTypes.CHATBOT_PUBLISHED.id" :activity="activity" />
    <PlanStarted v-else-if="activity.type === ActivityTypes.PLAN_STARTED.id" :activity="activity" />
    <PlanCanceled v-else-if="activity.type === ActivityTypes.PLAN_CANCELED.id" :activity="activity" />
    <WhatsappV1BotStateChanged
        v-else-if="activity.type === ActivityTypes.WHATSAPP_V1_BOT_STATE_CHANGED.id"
        :activity="activity"
    />
    <WhatsappV2BotStateChanged
        v-else-if="activity.type === ActivityTypes.WHATSAPP_V2_BOT_STATE_CHANGED.id"
        :activity="activity"
    />
    <WabaSupsisPartnerRemove
        v-else-if="activity.type === ActivityTypes.WABA_SUPSIS_PARTNER_REMOVE.id || activity.type === ActivityTypes.WABA_SUPSIS_PARTNER_REMOVE_LEGACY.id"
        :activity="activity"
    />
    <WabaSupsisPartnerAdded
        v-else-if="activity.type === ActivityTypes.WABA_SUPSIS_PARTNER_ADDED.id"
        :activity="activity"
    />
    <WabaSupsisAccountDeleted
        v-else-if="activity.type === ActivityTypes.WABA_SUPSIS_ACCOUNT_DELETED.id || activity.type === ActivityTypes.WABA_SUPSIS_ACCOUNT_DELETED_LEGACY.id"
        :activity="activity"
    />
    <WabaSupsisAccountViolation
        v-else-if="activity.type === ActivityTypes.WABA_SUPSIS_ACCOUNT_VIOLATION.id"
        :activity="activity"
    />
    <WabaSupsisAdAccountLinked
        v-else-if="activity.type === ActivityTypes.WABA_SUPSIS_AD_ACCOUNT_LINKED.id"
        :activity="activity"
    />
    <WabaSupsisAuthIntlPriceEligibilityUpdate
        v-else-if="activity.type === ActivityTypes.WABA_SUPSIS_AUTH_INTL_PRICE_ELIGIBILITY_UPDATE.id"
        :activity="activity"
    />
    <WabaSupsisDisabledUpdate
        v-else-if="activity.type === ActivityTypes.WABA_SUPSIS_DISABLED_UPDATE.id"
        :activity="activity"
    />
    <WabaSupsisMmLiteTermsSigned
        v-else-if="activity.type === ActivityTypes.WABA_SUPSIS_MM_LITE_TERMS_SIGNED.id"
        :activity="activity"
    />
    <WabaSupsisPartnerAppInstalled
        v-else-if="activity.type === ActivityTypes.WABA_SUPSIS_PARTNER_APP_INSTALLED.id"
        :activity="activity"
    />
    <WabaSupsisPartnerAppUninstalled
        v-else-if="activity.type === ActivityTypes.WABA_SUPSIS_PARTNER_APP_UNINSTALLED.id"
        :activity="activity"
    />
    <WabaSupsisPartnerClientCertificationStatusUpdate
        v-else-if="activity.type === ActivityTypes.WABA_SUPSIS_PARTNER_CLIENT_CERTIFICATION_STATUS_UPDATE.id"
        :activity="activity"
    />
    <WabaSupsisBusinessPrimaryLocationCountryUpdate
        v-else-if="activity.type === ActivityTypes.WABA_SUPSIS_BUSINESS_PRIMARY_LOCATION_COUNTRY_UPDATE.id"
        :activity="activity"
    />
    <WabaSupsisVolumeBasedPricingTierUpdate
        v-else-if="activity.type === ActivityTypes.WABA_SUPSIS_VOLUME_BASED_PRICING_TIER_UPDATE.id"
        :activity="activity"
    />
    <WabaSupsisMessageTemplateComponentsUpdate
        v-else-if="activity.type === ActivityTypes.WABA_SUPSIS_MESSAGE_TEMPLATE_COMPONENTS_UPDATE.id"
        :activity="activity"
    />
    <WabaSupsisMessageTemplateStatusUpdate
        v-else-if="activity.type === ActivityTypes.WABA_SUPSIS_MESSAGE_TEMPLATE_STATUS_UPDATE.id"
        :activity="activity"
    />
    <WabaSupsisTemplateCategoryUpdate
        v-else-if="activity.type === ActivityTypes.WABA_SUPSIS_TEMPLATE_CATEGORY_UPDATE.id"
        :activity="activity"
    />
    <ReservationCreatedPlan
        v-else-if="activity.type === ActivityTypes.RESERVATION_CREATED_PLAN.id"
        :activity="activity"
    />
    <ReservationUpdatedPlan
        v-else-if="activity.type === ActivityTypes.RESERVATION_UPDATED_PLAN.id"
        :activity="activity"
    />
    <ReservationDeletedPlan
        v-else-if="activity.type === ActivityTypes.RESERVATION_DELETED_PLAN.id"
        :activity="activity"
    />
    <ReservationCreated v-else-if="activity.type === ActivityTypes.RESERVATION_CREATED.id" :activity="activity" />
    <ReservationUpdated v-else-if="activity.type === ActivityTypes.RESERVATION_UPDATED.id" :activity="activity" />
    <ReservationDeleted v-else-if="activity.type === ActivityTypes.RESERVATION_DELETED.id" :activity="activity" />
    <ContactOwnerUpdated v-else-if="activity.type === ActivityTypes.CONTACT_OWNER_UPDATED.id" :activity="activity" />
    <WhiteListAdded v-else-if="activity.type === ActivityTypes.WHITE_LIST_ADDED.id" :activity="activity" />
    <WhiteListRemoved v-else-if="activity.type === ActivityTypes.WHITE_LIST_REMOVED.id" :activity="activity" />
    <AutoRebalanceSuccess v-else-if="activity.type === ActivityTypes.AUTO_REBALANCE_SUCCESS.id" :activity="activity" />
    <AutoRebalanceFailed v-else-if="activity.type === ActivityTypes.AUTO_REBALANCE_FAILED.id" :activity="activity" />
    <AutoRebalanceDisabled v-else-if="activity.type === ActivityTypes.AUTO_REBALANCE_DISABLED.id" :activity="activity" />
    <AutomationCreated v-else-if="activity.type === ActivityTypes.AUTOMATION_CREATED.id" :activity="activity" />
    <AutomationDeleted v-else-if="activity.type === ActivityTypes.AUTOMATION_DELETED.id" :activity="activity" />
    <AutomationRestored v-else-if="activity.type === ActivityTypes.AUTOMATION_RESTORED.id" :activity="activity" />
    <AutomationPublished v-else-if="activity.type === ActivityTypes.AUTOMATION_PUBLISHED.id" :activity="activity" />
    <AutomationUnpublished v-else-if="activity.type === ActivityTypes.AUTOMATION_UNPUBLISHED.id" :activity="activity" />
    <AutomationUpdated v-else-if="activity.type === ActivityTypes.AUTOMATION_UPDATED.id" :activity="activity" />
    <FormCreated v-else-if="activity.type === ActivityTypes.FORM_CREATED.id" :activity="activity" />
    <FormUpdated v-else-if="activity.type === ActivityTypes.FORM_UPDATED.id" :activity="activity" />
    <FormDeleted v-else-if="activity.type === ActivityTypes.FORM_DELETED.id" :activity="activity" />
    <FormRestored v-else-if="activity.type === ActivityTypes.FORM_RESTORED.id" :activity="activity" />
    <FormDownloaded v-else-if="activity.type === ActivityTypes.FORM_DOWNLOADED.id" :activity="activity" />
    <UserRoleChanged v-else-if="activity.type === ActivityTypes.USER_ROLE_CHANGED.id" :activity="activity" />
    <UserPasswordChanged v-else-if="activity.type === ActivityTypes.USER_PASSWORD_CHANGED.id" :activity="activity" />
    <UserEmailChanged v-else-if="activity.type === ActivityTypes.USER_EMAIL_CHANGED.id" :activity="activity" />
    <UserNameChanged v-else-if="activity.type === ActivityTypes.USER_NAME_CHANGED.id" :activity="activity" />
    <UserPhoneChanged v-else-if="activity.type === ActivityTypes.USER_PHONE_CHANGED.id" :activity="activity" />
    <UserDisabled v-else-if="activity.type === ActivityTypes.USER_DISABLED.id" :activity="activity" />
    <RoleUpdated v-else-if="activity.type === ActivityTypes.ROLE_UPDATED.id" :activity="activity" />
    <TaskWorkflowUpdated v-else-if="activity.type === ActivityTypes.TASK_WORKFLOW_UPDATED.id" :activity="activity" />
    <TaskWorkflowPipelineStageAdded v-else-if="activity.type === ActivityTypes.TASK_WORKFLOW_PIPELINE_STAGE_ADDED.id" :activity="activity" />
    <TaskWorkflowPipelineStageUpdated v-else-if="activity.type === ActivityTypes.TASK_WORKFLOW_PIPELINE_STAGE_UPDATED.id" :activity="activity" />
    <TaskWorkflowPipelineStageDeleted v-else-if="activity.type === ActivityTypes.TASK_WORKFLOW_PIPELINE_STAGE_DELETED.id" :activity="activity" />
    <DriveFolderCreated v-else-if="activity.type === ActivityTypes.DRIVE_FOLDER_CREATED.id" :activity="activity" />
    <DriveFolderDeleted v-else-if="activity.type === ActivityTypes.DRIVE_FOLDER_DELETED.id" :activity="activity" />
    <DriveFolderRenamed v-else-if="activity.type === ActivityTypes.DRIVE_FOLDER_RENAMED.id" :activity="activity" />
    <DriveFileAdded v-else-if="activity.type === ActivityTypes.DRIVE_FILE_ADDED.id" :activity="activity" />
    <DriveFileDeleted v-else-if="activity.type === ActivityTypes.DRIVE_FILE_DELETED.id" :activity="activity" />
    <TaskModuleRulesEnabled v-else-if="activity.type === ActivityTypes.TASK_MODULE_RULES_ENABLED.id" :activity="activity" />
    <TaskModuleRulesDisabled v-else-if="activity.type === ActivityTypes.TASK_MODULE_RULES_DISABLED.id" :activity="activity" />
    <TaskModuleRulesRuleAdded v-else-if="activity.type === ActivityTypes.TASK_MODULE_RULES_RULE_ADDED.id" :activity="activity" />
    <TaskModuleRulesRuleDeleted v-else-if="activity.type === ActivityTypes.TASK_MODULE_RULES_RULE_DELETED.id" :activity="activity" />
    <TaskModuleRulesRuleUpdated v-else-if="activity.type === ActivityTypes.TASK_MODULE_RULES_RULE_UPDATED.id" :activity="activity" />
    <TaskModuleRulesRuleEnabled v-else-if="activity.type === ActivityTypes.TASK_MODULE_RULES_RULE_ENABLED.id" :activity="activity" />
    <TaskModuleRulesRuleDisabled v-else-if="activity.type === ActivityTypes.TASK_MODULE_RULES_RULE_DISABLED.id" :activity="activity" />
    <ContactModuleRulesEnabled v-else-if="activity.type === ActivityTypes.CONTACT_MODULE_RULES_ENABLED.id" :activity="activity" />
    <ContactModuleRulesDisabled v-else-if="activity.type === ActivityTypes.CONTACT_MODULE_RULES_DISABLED.id" :activity="activity" />
    <ContactModuleRulesRuleAdded v-else-if="activity.type === ActivityTypes.CONTACT_MODULE_RULES_RULE_ADDED.id" :activity="activity" />
    <ContactModuleRulesRuleUpdated v-else-if="activity.type === ActivityTypes.CONTACT_MODULE_RULES_RULE_UPDATED.id" :activity="activity" />
    <ContactModuleRulesRuleDeleted v-else-if="activity.type === ActivityTypes.CONTACT_MODULE_RULES_RULE_DELETED.id" :activity="activity" />
    <ContactModuleRulesRuleEnabled v-else-if="activity.type === ActivityTypes.CONTACT_MODULE_RULES_RULE_ENABLED.id" :activity="activity" />
    <ContactModuleRulesRuleDisabled v-else-if="activity.type === ActivityTypes.CONTACT_MODULE_RULES_RULE_DISABLED.id" :activity="activity" />
    <DeveloperTokenChanged v-else-if="activity.type === ActivityTypes.DEVELOPER_TOKEN_CHANGED.id" :activity="activity" />
    <TableCreated v-else-if="activity.type === ActivityTypes.TABLE_CREATED.id" :activity="activity" />
    <TableDeleted v-else-if="activity.type === ActivityTypes.TABLE_DELETED.id" :activity="activity" />
    <TableRestored v-else-if="activity.type === ActivityTypes.TABLE_RESTORED.id" :activity="activity" />
    <TablePermanentlyDeleted v-else-if="activity.type === ActivityTypes.TABLE_PERMANENTLY_DELETED.id" :activity="activity" />
    <TableFieldAdded v-else-if="activity.type === ActivityTypes.TABLE_FIELD_ADDED.id" :activity="activity" />
    <TableFieldUpdated v-else-if="activity.type === ActivityTypes.TABLE_FIELD_UPDATED.id" :activity="activity" />
    <TableFieldDeleted v-else-if="activity.type === ActivityTypes.TABLE_FIELD_DELETED.id" :activity="activity" />
    <TableViewAdded v-else-if="activity.type === ActivityTypes.TABLE_VIEW_ADDED.id" :activity="activity" />
    <TableViewUpdated v-else-if="activity.type === ActivityTypes.TABLE_VIEW_UPDATED.id" :activity="activity" />
    <TableViewDeleted v-else-if="activity.type === ActivityTypes.TABLE_VIEW_DELETED.id" :activity="activity" />
    <TablePageAdded v-else-if="activity.type === ActivityTypes.TABLE_PAGE_ADDED.id" :activity="activity" />
    <TablePageUpdated v-else-if="activity.type === ActivityTypes.TABLE_PAGE_UPDATED.id" :activity="activity" />
    <TablePageDeleted v-else-if="activity.type === ActivityTypes.TABLE_PAGE_DELETED.id" :activity="activity" />
    <TableWidgetAdded v-else-if="activity.type === ActivityTypes.TABLE_WIDGET_ADDED.id" :activity="activity" />
    <TableWidgetUpdated v-else-if="activity.type === ActivityTypes.TABLE_WIDGET_UPDATED.id" :activity="activity" />
    <TableWidgetDeleted v-else-if="activity.type === ActivityTypes.TABLE_WIDGET_DELETED.id" :activity="activity" />
    <TablePermissionChanged v-else-if="activity.type === ActivityTypes.TABLE_PERMISSION_CHANGED.id" :activity="activity" />
    <TableDataDownloaded v-else-if="activity.type === ActivityTypes.TABLE_DATA_DOWNLOADED.id" :activity="activity" />
    <TableDataImported v-else-if="activity.type === ActivityTypes.TABLE_DATA_IMPORTED.id" :activity="activity" />
    <TableDataBatchUpdated v-else-if="activity.type === ActivityTypes.TABLE_DATA_BATCH_UPDATED.id" :activity="activity" />
    <TableDataBatchDeleted v-else-if="activity.type === ActivityTypes.TABLE_DATA_BATCH_DELETED.id" :activity="activity" />
    <ContactBatchUpdated v-else-if="activity.type === ActivityTypes.CONTACT_BATCH_UPDATED.id" :activity="activity" />
    <ChatDataDownloaded v-else-if="activity.type === ActivityTypes.CHAT_DATA_DOWNLOADED.id" :activity="activity" />
    <WebAppCreated v-else-if="activity.type === ActivityTypes.WEB_APP_CREATED.id" :activity="activity" />
    <WebAppUpdated v-else-if="activity.type === ActivityTypes.WEB_APP_UPDATED.id" :activity="activity" />
    <WebAppDeleted v-else-if="activity.type === ActivityTypes.WEB_APP_DELETED.id" :activity="activity" />
    <WebTabCreated v-else-if="activity.type === ActivityTypes.WEB_TAB_CREATED.id" :activity="activity" />
    <WebTabUpdated v-else-if="activity.type === ActivityTypes.WEB_TAB_UPDATED.id" :activity="activity" />
    <WebTabDeleted v-else-if="activity.type === ActivityTypes.WEB_TAB_DELETED.id" :activity="activity" />
    <ModuleCreated v-else-if="activity.type === ActivityTypes.MODULE_CREATED.id" :activity="activity" />
    <ModuleUpdated v-else-if="activity.type === ActivityTypes.MODULE_UPDATED.id" :activity="activity" />
    <ModuleDeleted v-else-if="activity.type === ActivityTypes.MODULE_DELETED.id" :activity="activity" />
    <RelationCreated v-else-if="activity.type === ActivityTypes.RELATION_CREATED.id" :activity="activity" />
    <RelationUpdated v-else-if="activity.type === ActivityTypes.RELATION_UPDATED.id" :activity="activity" />
    <VoiceAgentCreated v-else-if="activity.type === ActivityTypes.VOICE_AGENT_CREATED.id" :activity="activity" />
    <VoiceAgentUpdated v-else-if="activity.type === ActivityTypes.VOICE_AGENT_UPDATED.id" :activity="activity" />
    <VoiceAgentDeleted v-else-if="activity.type === ActivityTypes.VOICE_AGENT_DELETED.id" :activity="activity" />
    <VoiceAgentPhoneNumberInboundAgentChanged v-else-if="activity.type === ActivityTypes.VOICE_AGENT_PHONE_NUMBER_INBOUND_AGENT_CHANGED.id" :activity="activity" />
    <VoiceAgentPhoneNumberOutboundAgentChanged v-else-if="activity.type === ActivityTypes.VOICE_AGENT_PHONE_NUMBER_OUTBOUND_AGENT_CHANGED.id" :activity="activity" />
    <VoiceAgentBatchCallCreated v-else-if="activity.type === ActivityTypes.VOICE_AGENT_BATCH_CALL_CREATED.id" :activity="activity" />
    <VoiceAgentKnowledgeBaseCreated v-else-if="activity.type === ActivityTypes.VOICE_AGENT_KNOWLEDGE_BASE_CREATED.id" :activity="activity" />
    <VoiceAgentKnowledgeBaseDeleted v-else-if="activity.type === ActivityTypes.VOICE_AGENT_KNOWLEDGE_BASE_DELETED.id" :activity="activity" />
    <CustomActivity v-else-if="activity.type === ActivityTypes.CUSTOM.id" :activity="activity" />
    <div v-else>
        {{ activity.type }}
    </div>
</template>
<script>
import Vue from "vue";
import UserStatusChanged from "./UserStatusChanged.vue";
import ActivityTypes from "../ActivityTypes";
import VisitorBlocked from "./VisitorBlocked.vue";
import VisitorUnBlocked from "./VisitorUnBlocked.vue";
import VisitorTagAdded from "./VisitorTagAdded.vue";
import VisitorTagRemoved from "./VisitorTagRemoved.vue";
import UserAdded from "./UserAdded.vue";
import ChannelCreated from "./ChannelCreated.vue";
import ChannelRemoved from "./ChannelRemoved.vue";
import ChatOpened from "./ChatOpened.vue";
import ChatClosed from "./ChatClosed.vue";
import WebhookAdded from "./WebhookAdded.vue";
import WebhookRemoved from "./WebhookRemoved.vue";
import WebhookUpdated from "./WebhookUpdated.vue";
import TriggerAdded from "./TriggerAdded.vue";
import TriggerRemoved from "./TriggerRemoved.vue";
import TriggerUpdated from "./TriggerUpdate.vue";
import DepartmentAdded from "./DepartmentAdded.vue";
import DepartmentRemoved from "./DepartmentRemoved.vue";
import RoleAdded from "./RoleAdded.vue";
import RoleRemoved from "./RoleRemoved.vue";
import TagsAdded from "./TagsAdded.vue";
import TagsRemoved from "./TagsRemoved.vue";
import WelcomeMessageAdded from "./WelcomeMessageAdded.vue";
import WelcomeMessageRemoved from "./WelcomeMessageRemoved.vue";
import BannedWordCreated from "./BannedWordCreated.vue";
import BannedWordRemoved from "./BannedWordRemoved.vue";
import TaskWorkflwCreated from "./TaskWorkflowCreated.vue";
import SettingsUpdated from "./SettingsUpdated.vue";
import MailAddressAdded from "./MailAddressAdded.vue";
import UserAddedToDepartment from "./UserAddedToDepartment.vue";
import UserRemovedFromDepartment from "./UserRemovedFromDepartment.vue";
import TaskDeleted from "./TaskDeleted.vue";
import ChannelVisibilityChanged from "./ChannelVisibilityChanged.vue";
import ChannelForwardConfigUpdated from "./ChannelForwardConfigUpdated.vue";
import ChannelZohoConfigUpdated from "./ChannelZohoConfigUpdated.vue";
import ContentAdded from "./ContentAdded.vue";
import ContentRemoved from "./ContentRemoved.vue";
import CustomerGroupAdded from "./CustomerGroupAdded.vue";
import CustomerGroupRemoved from "./CustomerGroupRemoved.vue";
import CustomerGroupUpdated from "./CustomerGroupUpdated.vue";
import ChatAssigned from "./ChatAssigned.vue";
import ChatForwarded from "./ChatForwarded.vue";
import ChatJoined from "./ChatJoined.vue";
import UserLoggedIn from "./UserLoggedIn.vue";
import TicketAssigned from "./TicketAssigned.vue";
import WhatsappBroadcastCreated from "./WhatsappBroadcastCreated.vue";
import WhatsappBroadcastCompleted from "./WhatsappBroadcastCompleted.vue";
import WhatsappBroadcastCancelled from "./WhatsappBroadcastCancelled.vue";
import WhatsappBroadcastFailed from "./WhatsappBroadcastFailed.vue";
import TaskWorkflowDeleted from "./TaskWorkflowDeleted.vue";
import TaskWorkflowRestored from "./TaskWorkflowRestored.vue";
import TaskWorkflowPermanentlyDeleted from "./TaskWorkflowPermanentlyDeleted.vue";
import BillingAddressUpdated from "./BillingAddressUpdated.vue";
import InvoiceCreated from "./InvoiceCreated.vue";
import InvoicePaymentReceived from "./InvoicePaymentReceived.vue";
import InvoicePaymentFailed from "./InvoicePaymentFailed.vue";
import PaymentMethodAdded from "./PaymentMethodAdded.vue";
import InvoiceRefunded from "./InvoiceRefunded.vue";
import LoginFormActivated from "./LoginFormActivated.vue";
import LoginFormDeactivated from "./LoginFormDeactivated.vue";
import LoginFormUpdated from "./LoginFormUpdated.vue";
import UserRemoved from "./UserRemoved.vue";
import ContactPropAdded from "./ContactPropAdded.vue";
import ContactPropRemoved from "./ContactPropRemoved.vue";
import TaskCreated from "./TaskCreated.vue";
import TaskStageChanged from "./TaskStageChanged.vue";
import TaskAssignedToUser from "./TaskAssignedToUser.vue";
import WhatsappCreditLow from "./WhatsappCreditLow.vue";
import ChatbotCreated from "./ChatbotCreated.vue";
import ChatBotCreditLow from "./ChatBotCreditLow.vue";
import ChatBotCreditDone from "./ChatBotCreditDone.vue";
import SystemStatusChanged from "./SystemStatusChanged.vue";
import ChatbotDeleted from "./ChatbotDeleted.vue";
import ChatbotRestored from "./ChatbotRestored.vue";
import ChatbotPublished from "./ChatbotPublished.vue";
import PlanStarted from "./PlanStarted.vue";
import PlanCanceled from "./PlanCanceled.vue";
import WhatsappV1BotStateChanged from "./Whatsappv1BotStateChanged.vue";
import WhatsappV2BotStateChanged from "./WhatsappV2BotStateChanged.vue";
import WabaSupsisPartnerRemove from "./WabaSupsisPartnerRemove.vue";
import WabaSupsisPartnerAdded from "./WabaSupsisPartnerAdded.vue";
import WabaSupsisAccountDeleted from "./WabaSupsisAccountDeleted.vue";
import WabaSupsisAccountViolation from "./WabaSupsisAccountViolation.vue";
import WabaSupsisAdAccountLinked from "./WabaSupsisAdAccountLinked.vue";
import WabaSupsisAuthIntlPriceEligibilityUpdate from "./WabaSupsisAuthIntlPriceEligibilityUpdate.vue";
import WabaSupsisDisabledUpdate from "./WabaSupsisDisabledUpdate.vue";
import WabaSupsisMmLiteTermsSigned from "./WabaSupsisMmLiteTermsSigned.vue";
import WabaSupsisPartnerAppInstalled from "./WabaSupsisPartnerAppInstalled.vue";
import WabaSupsisPartnerAppUninstalled from "./WabaSupsisPartnerAppUninstalled.vue";
import WabaSupsisPartnerClientCertificationStatusUpdate from "./WabaSupsisPartnerClientCertificationStatusUpdate.vue";
import WabaSupsisBusinessPrimaryLocationCountryUpdate from "./WabaSupsisBusinessPrimaryLocationCountryUpdate.vue";
import WabaSupsisVolumeBasedPricingTierUpdate from "./WabaSupsisVolumeBasedPricingTierUpdate.vue";
import WabaSupsisMessageTemplateComponentsUpdate from "./WabaSupsisMessageTemplateComponentsUpdate.vue";
import WabaSupsisMessageTemplateStatusUpdate from "./WabaSupsisMessageTemplateStatusUpdate.vue";
import WabaSupsisTemplateCategoryUpdate from "./WabaSupsisTemplateCategoryUpdate.vue";
import ReservationCreatedPlan from "./ReservationCreatedPlan.vue";
import ReservationUpdatedPlan from "./ReservationUpdatedPlan.vue";
import ReservationDeletedPlan from "./ReservationDeletedPlan.vue";
import ReservationCreated from "./ReservationCreated.vue";
import ReservationUpdated from "./ReservationUpdated.vue";
import ReservationDeleted from "./ReservationDeleted.vue";
import ContactOwnerUpdated from "./ContactOwnerUpdated.vue";
import WhiteListAdded from "./WhiteListAdded.vue";
import WhiteListRemoved from "./WhiteListRemoved.vue";
import AutoRebalanceSuccess from "./AutoRebalanceSuccess.vue";
import AutoRebalanceFailed from "./AutoRebalanceFailed.vue";
import AutoRebalanceDisabled from "./AutoRebalanceDisabled.vue";
import TaskUpdatedPriority from "./TaskUpdatedPriority.vue";
import TaskAddedTags from "./TaskAddedTags.vue";
import TaskRemovedTags from "./TaskRemovedTags.vue";
import TaskUpdateTitle from "./TaskUpdateTitle.vue";
import TaskUpdateDescription from "./TaskUpdateDescription.vue";
import TaskUpdateStartDate from "./TaskUpdateStartDate.vue";
import TaskUpdateEndDate from "./TaskUpdateEndDate.vue";
import TaskUpdateOwner from "./TaskUpdateOwner.vue";
import TaskAddedFollowers from "./TaskAddedFollowers.vue";
import TaskRemovedFollowers from "./TaskRemovedFollowers.vue";
import TaskAddedCollaborators from "./TaskAddedCollaborators.vue";
import TaskUpdateChecklist from "./TaskUpdateChecklist.vue";
import TaskAddedSubtask from "./TaskAddedSubtask.vue";
import TaskRemovedSubtask from "./TaskRemovedSubtask.vue";
import TaskAddedAttachment from "./TaskAddedAttachment.vue";
import TaskComplet from "./TaskComplet.vue";
import TaskArchived from "./TaskArchived.vue";
import TaskRestored from "./TaskRestored.vue";
import TaskUnarchived from "./TaskUnarchived.vue";
import AutomationCreated from "./AutomationCreated.vue";
import AutomationDeleted from "./AutomationDeleted.vue";
import AutomationRestored from "./AutomationRestored.vue";
import AutomationPublished from "./AutomationPublished.vue";
import AutomationUnpublished from "./AutomationUnpublished.vue";
import AutomationUpdated from "./AutomationUpdated.vue";
import FormCreated from "./FormCreated.vue";
import FormUpdated from "./FormUpdated.vue";
import FormDeleted from "./FormDeleted.vue";
import FormRestored from "./FormRestored.vue";
import FormDownloaded from "./FormDownloaded.vue";
import UserRoleChanged from "./UserRoleChanged.vue";
import UserPasswordChanged from "./UserPasswordChanged.vue";
import UserEmailChanged from "./UserEmailChanged.vue";
import UserNameChanged from "./UserNameChanged.vue";
import UserPhoneChanged from "./UserPhoneChanged.vue";
import UserDisabled from "./UserDisabled.vue";
import RoleUpdated from "./RoleUpdated.vue";
import TaskWorkflowUpdated from "./TaskWorkflowUpdated.vue";
import TaskWorkflowPipelineStageAdded from "./TaskWorkflowPipelineStageAdded.vue";
import TaskWorkflowPipelineStageUpdated from "./TaskWorkflowPipelineStageUpdated.vue";
import TaskWorkflowPipelineStageDeleted from "./TaskWorkflowPipelineStageDeleted.vue";
import DriveFolderCreated from "./DriveFolderCreated.vue";
import DriveFolderDeleted from "./DriveFolderDeleted.vue";
import DriveFolderRenamed from "./DriveFolderRenamed.vue";
import DriveFileAdded from "./DriveFileAdded.vue";
import DriveFileDeleted from "./DriveFileDeleted.vue";
import TaskModuleRulesEnabled from "./TaskModuleRulesEnabled.vue";
import TaskModuleRulesDisabled from "./TaskModuleRulesDisabled.vue";
import TaskModuleRulesRuleAdded from "./TaskModuleRulesRuleAdded.vue";
import TaskModuleRulesRuleDeleted from "./TaskModuleRulesRuleDeleted.vue";
import TaskModuleRulesRuleUpdated from "./TaskModuleRulesRuleUpdated.vue";
import TaskModuleRulesRuleEnabled from "./TaskModuleRulesRuleEnabled.vue";
import TaskModuleRulesRuleDisabled from "./TaskModuleRulesRuleDisabled.vue";
import ContactModuleRulesEnabled from "./ContactModuleRulesEnabled.vue";
import ContactModuleRulesDisabled from "./ContactModuleRulesDisabled.vue";
import ContactModuleRulesRuleAdded from "./ContactModuleRulesRuleAdded.vue";
import ContactModuleRulesRuleUpdated from "./ContactModuleRulesRuleUpdated.vue";
import ContactModuleRulesRuleDeleted from "./ContactModuleRulesRuleDeleted.vue";
import ContactModuleRulesRuleEnabled from "./ContactModuleRulesRuleEnabled.vue";
import ContactModuleRulesRuleDisabled from "./ContactModuleRulesRuleDisabled.vue";
import DeveloperTokenChanged from "./DeveloperTokenChanged.vue";
import TableCreated from "./TableCreated.vue";
import TableDeleted from "./TableDeleted.vue";
import TableRestored from "./TableRestored.vue";
import TablePermanentlyDeleted from "./TablePermanentlyDeleted.vue";
import TableFieldAdded from "./TableFieldAdded.vue";
import TableFieldUpdated from "./TableFieldUpdated.vue";
import TableFieldDeleted from "./TableFieldDeleted.vue";
import TableViewAdded from "./TableViewAdded.vue";
import TableViewUpdated from "./TableViewUpdated.vue";
import TableViewDeleted from "./TableViewDeleted.vue";
import TablePageAdded from "./TablePageAdded.vue";
import TablePageUpdated from "./TablePageUpdated.vue";
import TablePageDeleted from "./TablePageDeleted.vue";
import TableWidgetAdded from "./TableWidgetAdded.vue";
import TableWidgetUpdated from "./TableWidgetUpdated.vue";
import TableWidgetDeleted from "./TableWidgetDeleted.vue";
import TablePermissionChanged from "./TablePermissionChanged.vue";
import TableDataDownloaded from "./TableDataDownloaded.vue";
import TableDataImported from "./TableDataImported.vue";
import TableDataBatchUpdated from "./TableDataBatchUpdated.vue";
import TableDataBatchDeleted from "./TableDataBatchDeleted.vue";
import ContactBatchUpdated from "./ContactBatchUpdated.vue";
import ChatDataDownloaded from "./ChatDataDownloaded.vue";
import WebAppCreated from "./WebAppCreated.vue";
import WebAppUpdated from "./WebAppUpdated.vue";
import WebAppDeleted from "./WebAppDeleted.vue";
import WebTabCreated from "./WebTabCreated.vue";
import WebTabUpdated from "./WebTabUpdated.vue";
import WebTabDeleted from "./WebTabDeleted.vue";
import ModuleCreated from "./ModuleCreated.vue";
import ModuleUpdated from "./ModuleUpdated.vue";
import ModuleDeleted from "./ModuleDeleted.vue";
import RelationCreated from "./RelationCreated.vue";
import RelationUpdated from "./RelationUpdated.vue";
import VoiceAgentCreated from "./VoiceAgentCreated.vue";
import VoiceAgentUpdated from "./VoiceAgentUpdated.vue";
import VoiceAgentDeleted from "./VoiceAgentDeleted.vue";
import VoiceAgentPhoneNumberInboundAgentChanged from "./VoiceAgentPhoneNumberInboundAgentChanged.vue";
import VoiceAgentPhoneNumberOutboundAgentChanged from "./VoiceAgentPhoneNumberOutboundAgentChanged.vue";
import VoiceAgentBatchCallCreated from "./VoiceAgentBatchCallCreated.vue";
import VoiceAgentKnowledgeBaseCreated from "./VoiceAgentKnowledgeBaseCreated.vue";
import VoiceAgentKnowledgeBaseDeleted from "./VoiceAgentKnowledgeBaseDeleted.vue";
import CustomActivity from "./CustomActivity.vue";

export default Vue.extend({
    name: "ActivityViewer",
    components: {
        WhiteListRemoved,
        WhiteListAdded,
        AutoRebalanceSuccess,
        AutoRebalanceFailed,
        AutoRebalanceDisabled,
        WhatsappBroadcastCancelled,
        WhatsappBroadcastFailed,
        WhatsappBroadcastCompleted,
        WhatsappBroadcastCreated,
        TicketAssigned,
        UserLoggedIn,
        ChatJoined,
        ChatForwarded,
        ChatAssigned,
        ChatClosed,
        ChatOpened,
        ChannelCreated,
        ChannelRemoved,
        UserAdded,
        VisitorUnBlocked,
        VisitorTagAdded,
        VisitorTagRemoved,
        VisitorBlocked,
        UserStatusChanged,
        WebhookAdded,
        WebhookRemoved,
        WebhookUpdated,
        TriggerAdded,
        TriggerRemoved,
        TriggerUpdated,
        DepartmentAdded,
        DepartmentRemoved,
        RoleAdded,
        RoleRemoved,
        TagsAdded,
        TagsRemoved,
        WelcomeMessageAdded,
        WelcomeMessageRemoved,
        BannedWordCreated,
        BannedWordRemoved,
        TaskWorkflwCreated,
        TaskUpdatedPriority,
        TaskAddedTags,
        TaskRemovedTags,
        TaskUpdateTitle,
        TaskUpdateDescription,
        TaskUpdateStartDate,
        TaskUpdateEndDate,
        TaskUpdateOwner,
        TaskAddedFollowers,
        TaskRemovedFollowers,
        TaskAddedCollaborators,
        TaskUpdateChecklist,
        TaskAddedSubtask,
        TaskRemovedSubtask,
        TaskAddedAttachment,
        SettingsUpdated,
        MailAddressAdded,
        UserAddedToDepartment,
        UserRemovedFromDepartment,
        TaskDeleted,
        ChannelVisibilityChanged,
        ChannelForwardConfigUpdated,
        ChannelZohoConfigUpdated,
        ContentAdded,
        ContentRemoved,
        CustomerGroupAdded,
        CustomerGroupRemoved,
        CustomerGroupUpdated,
        TaskWorkflowDeleted,
        TaskWorkflowRestored,
        TaskWorkflowPermanentlyDeleted,
        BillingAddressUpdated,
        InvoiceCreated,
        InvoicePaymentReceived,
        InvoicePaymentFailed,
        PaymentMethodAdded,
        InvoiceRefunded,
        LoginFormActivated,
        LoginFormDeactivated,
        LoginFormUpdated,
        UserRemoved,
        ContactPropAdded,
        ContactPropRemoved,
        TaskCreated,
        TaskStageChanged,
        TaskAssignedToUser,
        WhatsappCreditLow,
        ChatbotCreated,
        ChatBotCreditLow,
        ChatBotCreditDone,
        SystemStatusChanged,
        ChatbotDeleted,
        ChatbotRestored,
        ChatbotPublished,
        PlanStarted,
        PlanCanceled,
        WhatsappV1BotStateChanged,
        WhatsappV2BotStateChanged,
        WabaSupsisPartnerRemove,
        WabaSupsisPartnerAdded,
        WabaSupsisAccountDeleted,
        WabaSupsisAccountViolation,
        WabaSupsisAdAccountLinked,
        WabaSupsisAuthIntlPriceEligibilityUpdate,
        WabaSupsisDisabledUpdate,
        WabaSupsisMmLiteTermsSigned,
        WabaSupsisPartnerAppInstalled,
        WabaSupsisPartnerAppUninstalled,
        WabaSupsisPartnerClientCertificationStatusUpdate,
        WabaSupsisBusinessPrimaryLocationCountryUpdate,
        WabaSupsisVolumeBasedPricingTierUpdate,
        WabaSupsisMessageTemplateComponentsUpdate,
        WabaSupsisMessageTemplateStatusUpdate,
        WabaSupsisTemplateCategoryUpdate,
        ReservationCreatedPlan,
        ReservationUpdatedPlan,
        ReservationDeletedPlan,
        ReservationCreated,
        ReservationUpdated,
        ReservationDeleted,
        ContactOwnerUpdated,
        TaskComplet,
        TaskArchived,
        TaskRestored,
        TaskUnarchived,
        AutomationCreated,
        AutomationDeleted,
        AutomationRestored,
        AutomationPublished,
        AutomationUnpublished,
        AutomationUpdated,
        FormCreated,
        FormUpdated,
        FormDeleted,
        FormRestored,
        FormDownloaded,
        UserRoleChanged,
        UserPasswordChanged,
        UserEmailChanged,
        UserNameChanged,
        UserPhoneChanged,
        UserDisabled,
        RoleUpdated,
        TaskWorkflowUpdated,
        TaskWorkflowPipelineStageAdded,
        TaskWorkflowPipelineStageUpdated,
        TaskWorkflowPipelineStageDeleted,
        DriveFolderCreated,
        DriveFolderDeleted,
        DriveFolderRenamed,
        DriveFileAdded,
        DriveFileDeleted,
        TaskModuleRulesEnabled,
        TaskModuleRulesDisabled,
        TaskModuleRulesRuleAdded,
        TaskModuleRulesRuleDeleted,
        TaskModuleRulesRuleUpdated,
        TaskModuleRulesRuleEnabled,
        TaskModuleRulesRuleDisabled,
        ContactModuleRulesEnabled,
        ContactModuleRulesDisabled,
        ContactModuleRulesRuleAdded,
        ContactModuleRulesRuleUpdated,
        ContactModuleRulesRuleDeleted,
        ContactModuleRulesRuleEnabled,
        ContactModuleRulesRuleDisabled,
        DeveloperTokenChanged,
        TableCreated,
        TableDeleted,
        TableRestored,
        TablePermanentlyDeleted,
        TableFieldAdded,
        TableFieldUpdated,
        TableFieldDeleted,
        TableViewAdded,
        TableViewUpdated,
        TableViewDeleted,
        TablePageAdded,
        TablePageUpdated,
        TablePageDeleted,
        TableWidgetAdded,
        TableWidgetUpdated,
        TableWidgetDeleted,
        TablePermissionChanged,
        TableDataDownloaded,
        TableDataImported,
        TableDataBatchUpdated,
        TableDataBatchDeleted,
        ContactBatchUpdated,
        ChatDataDownloaded,
        WebAppCreated,
        WebAppUpdated,
        WebAppDeleted,
        WebTabCreated,
        WebTabUpdated,
        WebTabDeleted,
        ModuleCreated,
        ModuleUpdated,
        ModuleDeleted,
        RelationCreated,
        RelationUpdated,
        VoiceAgentCreated,
        VoiceAgentUpdated,
        VoiceAgentDeleted,
        VoiceAgentPhoneNumberInboundAgentChanged,
        VoiceAgentPhoneNumberOutboundAgentChanged,
        VoiceAgentBatchCallCreated,
        VoiceAgentKnowledgeBaseCreated,
        VoiceAgentKnowledgeBaseDeleted,
        CustomActivity,
    },
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            ActivityTypes,
        };
    },
});
</script>

<style scoped lang="scss"></style>
